'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var context = '@@clickoutsideContext';
var clickOutside = {
  bind: function bind(el, binding) {
    var handler = function handler(event) {
      if (!el.contains(event.target)) {
        el[context].callback();
      }
    };

    el[context] = {
      handler: handler,
      callback: binding.value,
      arg: binding.arg || 'click'
    };
    document.addEventListener(el[context].arg, handler);
  },
  update: function update(el, binding) {
    el[context].callback = binding.value;
  },
  unbind: function unbind(el) {
    document.removeEventListener(el[context].arg, el[context].handler);
  }
};

exports.default = clickOutside;
